import { Box, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CusLink from '../../../../../components/material-ui/CusLink';
import TabsLanguage from '../../../../../components/widgets/TabsLanguage';
import CusInput from '../../../../../components/material-ui/CusInput';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import useNumberParams from '../../../../../hooks/useNumberParams';
import { API_CASINO } from '../../../../../api/casino';
import useToast from '../../../../../hooks/useToast';

export default function CasinoChatTawkContent() {
  const { t } = useTranslation();
  const { successToast } = useToast();
  const [lang, setLang] = useState();
  const [tawkInfoLang, setTawkInfoLang] = useState({});
  const casinoId = useNumberParams('casinoId');

  useEffect(() => {
    API_CASINO.liveChat
      .get({ casinoId })
      .then((e) => {
        const data = e.data.data || {};
        setTawkInfoLang(data);
      })
      .catch(console.error);
  }, [casinoId]);

  const onSaveClick = () => {
    console.log('tawkInfoLang', tawkInfoLang);

    API_CASINO.liveChat
      .set({ casinoId, data: tawkInfoLang })
      .then(() => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  return (
    <Stack gap={2}>
      <Box component={'span'}>
        <Typography component={'span'}>{t('Parameters')}</Typography>{' '}
        <CusLink
          text="tawk.io"
          href="https://www.tawk.to/"
          target="_blank"
          component="span"
          linkComponent="a"
        />
      </Box>
      <Stack gap={1}>
        <TabsLanguage lang={lang} setLang={setLang} />
        <Stack gap={0.5} key={lang + '_tawk_inputs'}>
          <CusInput
            value={tawkInfoLang[lang]?.propertyId}
            label={'propertyId'}
            onChange={(e) => {
              const value = e.target.value;

              setTawkInfoLang((prev) => {
                const prevInfo = JSON.parse(JSON.stringify(prev));
                if (!prevInfo[lang]) prevInfo[lang] = {};
                prevInfo[lang].propertyId = value;
                return prevInfo;
              });
            }}
          />
          <CusInput
            label={'widgetId'}
            value={tawkInfoLang[lang]?.widgetId}
            onChange={(e) => {
              const value = e.target.value;

              setTawkInfoLang((prev) => {
                const prevInfo = JSON.parse(JSON.stringify(prev));
                if (!prevInfo[lang]) prevInfo[lang] = {};
                prevInfo[lang].widgetId = value;
                return prevInfo;
              });
            }}
          />
        </Stack>
      </Stack>
      <CasinoBtnSave onClick={onSaveClick} />
    </Stack>
  );
}
